import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix 2FA icon. Exported from Figma (Bombiix 2026). */
const TwoFAIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M9.99967 16.6673C13.6816 16.6673 16.6663 13.6825 16.6663 10.0007C16.6663 6.31875 13.6816 3.33398 9.99967 3.33398C6.31778 3.33398 3.33301 6.31875 3.33301 10.0007C3.33301 13.6825 6.31778 16.6673 9.99967 16.6673Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99941 11.9189C9.39274 11.9189 8.89941 11.4256 8.89941 10.8189V9.17228C8.89941 8.56562 9.39274 8.07227 9.99941 8.07227C10.6061 8.07227 11.0994 8.56562 11.0994 9.17228V10.8189C11.0994 11.4256 10.6061 11.9189 9.99941 11.9189Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M13.3203 10.9798C13.187 12.6998 11.747 14.0465 10.0003 14.0465C8.16033 14.0465 6.66699 12.5531 6.66699 10.7131V9.28646C6.66699 7.44646 8.16033 5.95312 10.0003 5.95312C11.727 5.95312 13.147 7.26645 13.3137 8.94645"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default TwoFAIcon;
